import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

import router from './../router'

import statistics from './modules/statistics'
import users from './modules/users'
import accessories from './modules/accessories'
import products from './modules/products'
import news from './modules/news'
import plans from './modules/plans'
import rates from './modules/rates'
import sub_groups from './modules/sub_groups'
import uri from './config'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    users_for_zmi: [
      {
        id: 1,
        name: 'Рубенцова Диана Матвеевна',
        profession: 'Сварщик',
        avatar: 'c3999d9cbcbc9c94.jpg'
      },
      {
        id: 2,
        name: 'Карпова Бронислава Даниловна',
        profession: 'Сварщик',
        avatar: '02003881c3c367e7.jpg'
      },
      {
        id: 3,
        name: 'Минаев Кузьма Алексеевич',
        profession: 'Сварщик',
        avatar: '00247c7cfc78feff.jpg'
      },
      {
        id: 4,
        name: 'Тимошенко Нестор Денисович',
        profession: 'Сварщик',
        avatar: '1f3c7c7c3c3c1c08.jpg'
      },
      {
        id: 5,
        name: 'Лаврентьев Митофан Сергеевич',
        profession: 'Сварщик',
        avatar: '0c1e3e163f0e1e03.jpg'
      },
      {
        id: 6,
        name: 'Остимчук Христофор Тимофеевич',
        profession: 'Сварщик',
        avatar: '00183c1c3e3e1c1c.jpg'
      }
    ],
    user: null,
    current_date: new Date(),
    show_route: null,
    baseURL: uri
  },
  mutations: {

    set_user(state, payload) {
      // изменяем состояние
      state.user = payload;
    },

    set_current_date(state, payload) {
      // изменяем состояние
      state.current_date = payload;
    },


    set_accessory_by_product(state, payload) {
      // изменяем состояние
      state.original_products.forEach((product) => {
        if (product._id == payload.product_id) {
          payload.accessory.quantity = 0
          product.accessories.push(payload.accessory)
        }
      })
    },
    set_product_by_plan(state, payload) {
      // изменяем состояние
      state.plans.forEach((plan) => {
        if (plan._id == payload.plan_id) {
          payload.product.quantity = 0
          plan.products.push(payload.product)
        }
      })
    },

    delete_accessory_by_product(state, payload) {
      // изменяем состояние
      state.original_products.forEach(product => {
        if (product._id == payload.product_id) {

          product.accessories.forEach((accessory, index) => {
            if (accessory._id == payload.accessory._id)
              product.accessories.splice(index)
          })
        }
      })
    },
    delete_product_by_plan(state, payload) {
      // изменяем состояние
      state.plans.forEach(plan => {
        if (plan._id == payload.plan_id) {

          plan.products.forEach((product, index) => {
            if (product._id == payload.product._id)
              plan.products.splice(index)
          })
        }
      })
    },
    set_quantity(state, payload) {
      console.log(state.original_products)
      state.original_products.forEach(product => {
        if (product._id == payload.product_id) {
          product.accessories.forEach((accessory, index) => {
            if (accessory._id == payload.accessory._id)
              product.accessories[index].quantity = payload.accessory.quantity
          })
        }
      })
    }
  },
  actions: {

    async load_user({ commit }) {

      const user_id = localStorage.getItem('_id')

      const instance = await axios.create({
        baseURL: uri,
        headers: {
          "Content-Type": "application/json",
          "X-token": localStorage.getItem("_token"),
          "title": localStorage.getItem("title"),
          "_id": localStorage.getItem("_id"),
        },

      });

      instance
        .get(`/users/${user_id}`)
        .then(r => r.data)
        .then(data => {
          commit('set_user', data.user)

        }).catch(() => {
          localStorage.removeItem("_token")
          localStorage.removeItem("_id")
          localStorage.removeItem("title")
          localStorage.removeItem('localStorageInitTime');

        })
    },



    async authenticate({ commit }, data) {
      return new Promise((resolve, reject) => {
        const instance = axios.create({
          baseURL: uri,
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${data}`
          },
        });

        instance
          .post('/password', data)
          .then(r => r.data)
          .then(result => {

            commit('set_user', result.user)
            localStorage.setItem("_token", result.user._token)
            localStorage.setItem("_id", result.user._id)
            localStorage.setItem("title", result.user.title)
            localStorage.setItem('localStorageInitTime', +new Date());

            router.push("/")
            resolve(result)
          }).catch(err => {
            console.log(err, 'Ошибка при авторизации');
            reject(err)
          })

      })

    },

    async update_product_accessory({ commit }, data) {

      const instance = await axios.create({
        baseURL: `${uri}/original_products`,
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${data}`
        },
      });

      instance
        .put('/update_accessory', data)
        .then(r => r.data)
        .then(() => {
          data.value ? commit('set_accessory_by_product', data) : commit('delete_accessory_by_product', data)
        })

      return false
    },

    async update_plan_product({ commit }, data) {

      const instance = await axios.create({
        baseURL: uri,
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${data}`
        },
      });
      console.log(data);
      instance
        .put('/plans/update_products', data)
        .then(r => r.data)
        .then(() => {
          commit('set_product_by_plan', data)
        })

      return false
    },

    async delete_plan_product({ commit }, data) {


      const instance = await axios.create({
        baseURL: uri,
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${data}`
        },
      });
      console.log(data);
      instance
        .put('/plans/delete_products', data)
        .then(r => r.data)
        .then(() => {

          commit('delete_product_by_plan', data)
        })

      return false
    },


    async update_product_accessory_quantity({ commit }, data) {


      const instance = await axios.create({
        baseURL: uri,
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${data}`
        },
      });

      instance
        .put('/original_products/update_quantity', data)
        .then(r => r.data)
        .then((result) => {
          commit('set_quantity', result)
        })

      return false
    },

    async update_plan_product_quantity({ commit }, data) {

      const instance = await axios.create({
        baseURL: uri,
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${data}`
        },
      });

      instance
        .put(`/plans/update_quantity/${data.group_id}`, data)
        .then(r => r.data)
        .then((result) => {
          commit('set_quantity', result)
        })

      return false
    },


  },
  getters: {
    get_baseURL: state => {
      return state.baseURL;
    },
    get_user: state => {
      return state.user;
    },
    get_current_date: state => {
      return state.current_date;
    },



  },
  modules: {
    statistics,
    users,
    accessories,
    products,
    news,
    plans,
    rates,
    sub_groups,
  }


})
